<template>
    <div class="news_tab">
        <div class="tab_list">
            <div class="tab_item hvr-wobble-bottom" v-for="(item, index) in TabList" :key="index" :class="TabCur == index ? 'active' : '' " @click="TabClick(item, index)">
                {{ item.name }}
            </div>
        </div>

        <div class="news_box" v-if="NewsList && NewsList.length">
            <div class="news_item  hvr-underline-from-center" v-for="(item, index) in NewsList" :key="index" @click="showNewsDetail( item )">
                <div class="img_box">
                     <img :src="item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1"  alt="">
                     <img :src="$ImgUrl + item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1"  alt="">
                </div>
                <div class="info_box">
                    <div class="news_title">
                        {{ item.news_title}}
                    </div>
                    <div class="news_time">
                        <span class="iconfont icon-shijian"></span> {{ item.create_time }}
                    </div>
                    <div class="news_content">
                        {{ item.news_content }}
                    </div>
                    <div class="more">
                        查看更多 >
                    </div>
                </div>
            </div>
        </div>

        <div class="noMore" v-else>
            <img src="../../assets/static/index/nomore.png" alt="">
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                TabList: [
                    { name:"组织建设", cate_id: 1 },{ name:"党章党规", cate_id: 7 },{ name:"党员先锋", cate_id: 24 },
                ],
                TabCur: 0,
                cate_id: 1,
                size:10,
                NewsList: [],
            }
        },
        mounted () {
            this.getNewsList();
        },
        methods: {
            // 点击tab
            TabClick ( item, index ) {
                this.TabCur = index
                this.cate_id = item.cate_id 
                this.getNewsList()
            },
            // 获取新闻列表
            async getNewsList () {
                let { cate_id, size } = this 
                let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id, pageSize: size })
                if ( res.data.code == 1 ) {
                    this.NewsList = res.data.res
                } 
            },
            // 查看新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path:`/newsDetail/${ item.news_id }`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            }
        }
    }
</script>
<style>
.hvr-underline-from-center:before {
    background: #2767c4 ;
    height: 2px;
}
</style>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.news_tab {
    width: 1200px;
    margin: 20px auto;
    .tab_list {
        display: flex;
        align-items: center;
        line-height: 60px;
        border-bottom: 1px solid #d40000;
        .tab_item {
            width: 150px;
            margin: 0 20px;
            text-align: center;
            font-size: 24px;
            color: #2767c4 ;
            font-weight: bold;
            position: relative;
            left: 0;
            top: 0;
            cursor: pointer;
        }
        .active {
            position: relative;
            left: 0;
            top: 0;
            &::after {
                content: "";
                width: 150px;
                height: 4px;
                background-color: #2767c4 ;
                position: absolute;
                left: 0;
                bottom: -2px;
            }
        }
    }

    .news_box {
        width: 100%;
        .news_item {
            width: 100%;
            display: flex;
            margin: 30px 0;
            padding: 20px 0;
            cursor: pointer;
            .img_box {
                width: 263px;
                height: 158px;
                img {
                    width: 263px;
                    height: 158px;
                }
            }
            .info_box {
                flex: 1;
                margin-left: 20px;
                .news_title {
                    font-size: 18px;
                    font-weight: bold;
                }
                .news_time {
                    font-size: 14px;
                    color: #c8c8c8;
                    line-height: 50px;
                }
                .news_content {
                    font-size: 16px;
                    color: #828282;
                    height: 60px;
                    @include MultipleRows(2);
                }
                .more {
                    font-size: 14px;
                    color: #bbbbbb;
                    line-height: 30px;
                }
            }
        }
    }
}
</style>